import { supabase } from './supabase';

// supabase-js doesn't expose a synchronous `currentUser` like the Flutter
// SDK does (`_client.auth.currentUser?.id`). The repositories supply the
// user id explicitly on every call because Kong doesn't reliably forward
// the JWT to PostgREST on this self-hosted stack (see migration_005/014
// comments in the Dart repos) — so we resolve it from the cached session.

export async function currentUserId(): Promise<string | undefined> {
  const { data } = await supabase.auth.getSession();
  return data.session?.user?.id;
}
